export default __webpack_public_path__ + "locales/pt-BR/Profile.json?hash=bda9de0af75686cccaf64da4139505fa";